import { styled } from "@mui/material";
import { BaseButton } from "components/buttons/BaseButton";
import { useEffect } from "react";
import { UseFormSetValue, FieldPath } from "react-hook-form";
import { useKeyPress } from "../../../../../hooks/useKeyPress";
import SelectDate from "../../../SelectDate";
import { ISignUpFieldValues } from "../AuthSignUp";

interface IProps {
  next: () => void;
  setValue: UseFormSetValue<ISignUpFieldValues>;
}

const SignUpBirthStep = (props: IProps) => {
  const { next, setValue } = props;

  const handleBirth = (value: number) => {
    setValue<FieldPath<ISignUpFieldValues>>("birthday", value);
  };
  const enterPressed = useKeyPress("Enter");

  useEffect(() => {
    if (enterPressed) {
      next();
    }
    // eslint-disable-next-line
  }, [enterPressed])

  return (
    <div>
      <SelectDate onChange={handleBirth}/>
      <StyledBaseButton>
        <BaseButton onClick={next}>Next</BaseButton>
      </StyledBaseButton>
    </div>
  );
};

export default SignUpBirthStep;

const StyledBaseButton = styled("div")({
  marginTop: "32px",
  ".tablet &, .phone &": {
    position: "absolute",
    marginTop: 0,
    bottom: "0",
    left: "0",
    width: "100%",
    padding: "16px 16px 32px",
    background: "rgba(255, 255, 255, 0.9)",
    borderRadius: "24px"
  }
});
